import script from "./common-main-header-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./common-main-header-menu.vue?vue&type=script&setup=true&lang=js"

import "./common-main-header-menu.vue?vue&type=style&index=0&id=7644ba3f&lang=scss"
import "./common-main-header-menu.vue?vue&type=style&index=1&id=7644ba3f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7644ba3f"]])

export default __exports__